import React from 'react'
// import { Link, StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'

const InputSubmit = styled.input`
  padding: 22px 16px !important;
  ::placeholder {
    /* Firefox, Chrome, Opera */
    color: black;
    font-size: 0.6em;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: black;
    font-size: 0.6em;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: black;
    font-size: 0.6em;
  }
`

const ButtonSubmit = styled.button`
  font-size: 0.875em;
  line-height: 1.2142857143em;
  letter-spacing: 0.1428571429em;
  background-color: #000;
  border-style: solid;
  /* border-width: 3px; */
  border-color: #000;
  border-radius: 0;

  color: #fff;
  cursor: pointer;
  outline: 0;
  display: inline-block;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  height: 5em;
  padding: 1.7em 2em;
  overflow: hidden;
  position: relative;
  transition: all 330ms cubic-bezier(0.42, 0.09, 0.12, 1);
`

const SubscribeForm = () => (
  <form
    name="subscribe"
    method="post"
    action="/thank-you"
    data-netlify="true"
    data-netlify-honeypot="bot-field"
  >
    <input type="hidden" name="bot-field" />
    <input type="hidden" name="form-name" value="subscribe" />
    <InputSubmit
      id="email"
      type="email"
      name="email"
      required
      className="w3-bar-item w3-input  w3-white w3-mobile"
      placeholder="Enter your Email*"
    />
     <label style={{display:"none"}} htmlFor="email">email</label>

    <ButtonSubmit
      type="submit"
      value="Submit"
      className="w3-bar-item w3-border w3-button w3-mobile"
    >
      Submit
    </ButtonSubmit>
  </form>
)

export default SubscribeForm

// https://help.campaignmonitor.com/confirmation-pages-subscribe-unsubscribe
